import { useDispatch } from "react-redux";
import { updateCurrentPage } from "../features/pagination/paginationSlice";

export const Pagination = ({ pagination }) => {
    const dispacth = useDispatch();
    const { currentPage, pageLength } = pagination;
    const paginArr = Array.from(Array(pageLength).keys());

    const pageHandler = (page) => {
        dispacth(updateCurrentPage(page));
    };

    return (
        <>
            <div className="md:w-4/12 mx-auto mt-6">
                <div className="flex items-center gap-2 justify-center">
                    {paginArr.map((page, index) => {
                        const p = page + 1;
                        return (
                            <button
                                onClick={() => pageHandler(p)}
                                key={index}
                                className={`h-8 w-8 bg-blue-200 ${
                                    currentPage === p
                                        ? "bg-blue-600 text-blue-200"
                                        : "text-blue-600"
                                } text-sm rounded`}
                            >
                                {p}
                            </button>
                        );
                    })}
                </div>
            </div>
        </>
    );
};
